import _ from "lodash";

export default {
    namespaced: true,

    state: {
        product: false,
        selectedSizes: [],
        reviews: [],
        questions: [],
        associatedProducts: [],
        lastViewedProducts: [],
        favoriteProducts: [],
        associatedAccessoryProducts: [],
        feedbackModal: null,
        modalSize: false,
        modalZoom: false,
        modalZoomImage: '',
        modalCertificateZoom: false,
        modalCertificateZoomImage: '',
        modalFavorites: false,
        modalComparison: false,
        zoomImage: null,
        favoriteProductItems: [],
        waitingListProductItems: [],
        comparisonProducts: [],
        modalDetail: false,
        callbackMutations: [],
        selectedProductDetails: {},
        skipAddToCartEvent: false,
        bonusAccumulationPercentage: 0,
        existUserOrderItem: false,
        existUserReview: false,
    },
    getters: {
        bonusAccumulationAmount (state, ) {
            return Math.floor(state.product.selling_price * state.bonusAccumulationPercentage / 100);
        },
        sizeSelected: (state, getters) => (productId, size) => {
            let product = getters.productSizes(productId);

            return product ? product.sizes.indexOf(size) !== -1 : false;
        },
        productSizes: state => (productId) => {
            return state.selectedSizes.find(item => item.productId === productId);
        },
        favoriteItemsCount: state => {
            return state.favoriteProducts.length;
        },
        comparisonItemsCount: state => {
            return state.comparisonProducts.length;
        },
        getSelectedProductDetails: (state) => (productId) => {
            return _.get(state.selectedProductDetails, productId);
        }
    },

    mutations: {
        setBonusAccumulationPercentage (state, bonusAccumulationPercentage) {
            state.bonusAccumulationPercentage = bonusAccumulationPercentage;
        },
        setSelectedSizes(state, products) {
            Vue.set(state.selectedSizes, products);
        },
        setSelectedProductDetails(state, details) {
            Vue.set(state.selectedProductDetails, details.id, details);
        },
        setProduct(state, product) {
            Vue.set(state, 'product', product);
        },
        toggleSize(state, {productId, size}) {
            const product = state.selectedSizes.find(item => item.productId === productId);

            if (product) {
                let sizeIndex = product.sizes.indexOf(size);

                if (sizeIndex !== -1) {
                    // remove size from list of selected
                    product.sizes.splice(sizeIndex, 1);

                    if (!product.sizes.length) {
                        let productIndex = state.selectedSizes
                            .map(item => item.productId)
                            .indexOf(productId);

                        state.selectedSizes.splice(productIndex, 1);
                    }
                } else {
                    // add size to selected
                    product.sizes.push(size);
                }
            } else {
                state.selectedSizes.push({
                    productId: productId,
                    sizes: [size]
                })
            }
        },

        clearSelection(state) {
            Vue.set(state, 'selectedSizes', []);
        },

        setReviews(state, reviews) {
            Vue.set(state, 'reviews', reviews);
        },

        setQuestions(state, questions) {
            Vue.set(state, 'questions', questions);
        },

        setAssociatedProducts(state, associatedProducts) {
            Vue.set(state, 'associatedProducts', associatedProducts);
        },

        setLastViewedProducts(state, lastViewedProducts) {
            Vue.set(state, 'lastViewedProducts', lastViewedProducts);
        },

        setAssociatedAccessoryProducts(state, products) {
            Vue.set(state, 'associatedAccessoryProducts', products);
        },

        setFavoriteProducts(state, favoriteProducts) {
            favoriteProducts = favoriteProducts.map(item => parseInt(item));
            Vue.set(state, 'favoriteProducts', favoriteProducts);
        },

        setFavoriteProductItems(state, favoriteProducts) {
            Vue.set(state, 'favoriteProductItems', favoriteProducts);
            Vue.set(state, 'favoriteProducts', favoriteProducts ? favoriteProducts.map(item => parseInt(item.id)) : []);
        },

        setComparisonProducts(state, products) {
            Vue.set(state, 'comparisonProducts', products);
        },

        setWaitingListProductItems(state, waitingListProducts) {
            Vue.set(state, 'waitingListProductItems', waitingListProducts);
        },

        openFeedbackModal(state, value) {
            Vue.set(state, 'feedbackModal', value);
        },

        hideFeedbackModal(state) {
            Vue.set(state, 'feedbackModal', null);
        },

        skipAddToCartEvent(state, value) {
            Vue.set(state, 'skipAddToCartEvent', !!value);
        },

        showProductSizeModal(state, callback = []) {
            state.modalSize = true;
            state.callbackMutations = callback;
        },

        hideProductSizeModal(state) {
            state.modalSize = false;
        },

        toggleProductSizeModal(state, status) {
            state.modalSize = !!status;
        },

        showDetailModal(state) {
            state.modalDetail = true;
        },

        hideDetailModal(state) {
            state.modalDetail = false;
        },

        toggleDetailModal(state, status) {
            state.modalDetail = !!status;
        },

        showProductZoomModal(state, image) {
            state.modalZoom = true;
            state.modalZoomImage = image;
        },

        hideProductZoomModal(state) {
            state.modalZoom = false;
            state.modalZoomImage = '';
        },

        showCertificateZoomModal(state, image) {
            state.modalCertificateZoom = true;
            state.modalCertificateZoomImage = image;
        },

        hideCertificateZoomModal(state) {
            state.modalCertificateZoom = false;
            state.modalCertificateZoomImage = '';
        },

        toggleFavoritesModal(state, status) {
            state.modalFavorites = typeof status !== 'undefined' ? status : !state.modalFavorites;
        },
        toggleComparisonModal(state, status) {
            state.modalComparison = typeof status !== 'undefined' ? status : !state.modalComparison;
        },
        setExistUserOrderItem(state, existOrderItem) {
            state.existUserOrderItem = existOrderItem;
        },
        setExistUserReview(state, existUserReview) {
            state.existUserReview = existUserReview;
        }
    },

    actions: {
        switchFavoriteProduct({commit, state}, {productId, status}) {
            return new Promise((resolve, reject) => {

                let requestType = status ? 'delete' : 'put';

                axios[requestType]('/account/favorites/' + productId)
                    .then(response => {
                        commit('setFavoriteProductItems', response.data.products);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        switchComparisonProduct({commit, state}, {productId, status}) {
            return new Promise((resolve, reject) => {
                let requestType = status ? 'delete' : 'put';

                axios[requestType]('/account/comparison/' + productId)
                    .then(response => {
                        commit('setComparisonProducts', response.data.products.map(p => parseInt(p.id)));

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        deleteComparisonProducts({commit}, {ids = []}) {
            return new Promise((resolve, reject) => {
                axios.post('/account/comparison/delete', {ids: ids})
                    .then(response => {
                        if (response.data.status === 'success') {
                            commit('setComparisonProducts', response.data.products.map(p => parseInt(p.id)));
                        } else {
                            alert('Что-то пошло не так...');
                        }

                        resolve(response.data);
                    })
                    .catch(error => {
                        alert('Что-то пошло не так...');

                        reject(error);
                    });
            });
        },
        deleteWaitingListProduct({commit, state}, productId) {
            return new Promise((resolve, reject) => {
                axios.delete(`/waiting-lists/${productId}`)
                    .then(response => {
                        if (response.data.status === 'success') {
                            commit('setWaitingListProductItems', response.data.products);
                        } else {
                            alert('Что-то пошло не так...');
                        }

                        resolve(response.data);
                    })
                    .catch(error => {
                        alert('Что-то пошло не так...');

                        reject(error);
                    })
            });
        },
        async update({commit}, productId) {
            axios.get('/products/' + productId + '/details/')
                .then(response => {
                    if (response.data.status === 'success') {
                        commit('setSelectedProductDetails', response.data.product);
                    }
                });
        },
    }
}
